import React, { useState } from 'react';
import GenerateReportModal from './GenerateReportModal';
import './Reports.css';

const Reports = () => {
  const [modalOpen, setModalOpen] = useState(null);

  const handleGenerateClick = (reportType) => {
    setModalOpen(reportType);
  };

  return (
    <div className="reports-page">
      <h1>Reports</h1>
      <div className="reports-grid">
        <div className="report-card">
          <h2>Device Report</h2>
          <p className="report-description">
            Report containing chronological data about the devices and their current associations and their statuses
          </p>
          <button 
            className="report-generate-btn"
            onClick={() => handleGenerateClick('Device Report')}
          >
            Generate
          </button>
        </div>
        <div className="report-card">
          <h2>User Report</h2>
          <p className="report-description">
            Report containing all the users that have onboarded on our platform and their current status
          </p>
          <button 
            className="report-generate-btn"
            onClick={() => handleGenerateClick('User Report')}
          >
            Generate
          </button>
        </div>
        <div className="report-card">
          <h2>User Device Report</h2>
          <p className="report-description">
            Report containing information on which user is currently mapped to how many devices and what the current status is
          </p>
          <button 
            className="report-generate-btn"
            onClick={() => handleGenerateClick('User Mapping Report')}
          >
            Generate
          </button>
        </div>
        <div className="report-card">
          <h2>User Activity Report</h2>
          <p className="report-description">
            Report containing information on the user activity with respect to devices and other actions
          </p>
          <button 
            className="report-generate-btn"
            onClick={() => handleGenerateClick('User Activity Report')}
          >
            Generate
          </button>
        </div>
      </div>
      {modalOpen && (
        <GenerateReportModal 
          reportType={modalOpen} 
          onClose={() => setModalOpen(null)}
        />
      )}
    </div>
  );
};

export default Reports;
